
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import TitleAndPromotions from '@/apps/shared/components/TitlesAndPromotions.vue';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';

    export default defineComponent({
        name: 'tabOne',
        components: {
            TitleAndPromotions,
        },
        data() {
            return {
                sendDataDiscount: null,
                titleAndPromotionDetails: {
                    title: "Caucion-Alquiler",
                    subTitle: "",
                    product: "Caucion-Alquiler",
                    icon: {
                        src: '/Logos/caucion.png',
                        alt: 'Caucion-Alquiler',
                        title: 'Caucion-Alquiler'
                    }
                } as TitleAndPromotionsDetails,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Caucion-Alquiler';
                const actualPath = '/caucion-alquiler';
                const actualStep = 'tab-one';
                // Llamamos al helper que se encarga de toda la l�gica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },
            async initWinseWidget() {
                const webSale = this.$store.getters.getWebSaleData;

                const importModule = new Function(
                    'url',
                    'return import(url)'
                );

                const module = await importModule(
                    'https://test.widgets.winse.online/winse_integration_worker.js'
                );

                const { RentalGuaranteeWidget } = module;

                const widget = new RentalGuaranteeWidget("widget_container", '01371adc-a314-43f4-92b5-632e4e59aa79');

                await widget.init({
                    operationContext: {
                        distribution: {
                            organization: {
                                value: webSale?.organizerCode
                                    ? `${webSale.organizerCode} - ${webSale.organizerName || ""}`.trim()
                                    : "100890 - Libres de Capital Federal - Socios",
                                label: "Organizaci�n",
                            },
                            producer: {
                                value: webSale?.producerCode
                                    ? `${webSale.producerCode} - ${webSale.producerName || ""}`.trim()
                                    : "207343 - Libres de Capital Federal - Socios",
                                label: "Productor",
                            },
                            seller: {
                                value: webSale?.salesmanCode
                                    ? `${webSale.salesmanCode} - ${webSale.salesmanName || ""}`.trim()
                                    : null,
                                label: "Vendedor",
                            },
                        },
                        channel: {
                            source: "cotizadores-clientes",
                        },
                        metadata: {
                            campaign: "cauciones-2026",
                            assistedSale: true,
                        },
                    },
                });
            },
            RedirectToHome() {
                let urlParams = new URLSearchParams(window.location.search);
                let parameter = urlParams.get('test');
                if (parameter != "test") {
                    window.location.href = "https://www.sancorseguros.com.ar/";
                }
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();
                this.RedirectToHome();
                await this.pageCustomization();
                await this.initWinseWidget();
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
